import { useEffect } from 'react';
import { useCurrentUser } from 'customHooks/useCurrentUser';

const useSift = () => {
    const currentUser = useCurrentUser();

    useEffect(() => {
        if (window._sift) {
            window._sift.push(['_setAccount', import.meta.env.VITE_DASHBOARD_SIFT_BEACON_KEY]);
            window._sift.push(['_setUserId', currentUser.uid]);
        }
    }, [currentUser]);
};

export { useSift };
